/* eslint-disable @typescript-eslint/naming-convention */

export class AzureADSettings {
    LinkUserEnabled = false;
    AzureADUserEnabled = false;
    ClientId = '';
    ClientSecretId = '';
    ClientSecretValue = '';
}
